<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>工单列表</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- <el-button type="primary" class="editbtn" @click="add">新增</el-button> -->
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="服务商">
            <el-select v-model="searchForm.supplierid">
              <el-option label="全部" value="" />
              <el-option
                v-for="item in baseData.supplierList"
                :key="item.id"
                :label="item.company"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status">
              <el-option label="全部" value="" />
              <el-option label="待接单" value="1" />
              <el-option label="已接单" value="2" />
              <el-option label="安装中" value="3" />
              <el-option label="已完成" value="4" />
              <el-option label="已驳回" value="8" />
            </el-select>
          </el-form-item>
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="公司 | 联系人 | 手机号码"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="sn" label="工单编号" width="190"/>
          <el-table-column label="商品信息">
            <template #default="scope">
              <el-popover v-for="(item, index) in scope.row.goods" :key="index" trigger="click">
                <template #reference>
                  <el-button style="float:left;margin:0 10px 10px 0;" type="primary" size="small">{{item.goods_name}}</el-button>
                </template>
                <div>{{item.catagory_name}}<span :v-if="item.goods_name">{{item.goods_name}}</span> X {{item.number}}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="联系人信息" width="190">
            <template #default="scope">
              <div>联系人：{{ scope.row.name }}</div>
              <div>手机号码：{{ scope.row.mobile }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="联系人地址"/>
          <el-table-column prop="supplier" label="服务商" width="120"/>
          <el-table-column prop="tag_price" label="金额" width="100"/>
          <el-table-column prop="transaction_id" label="微信订单号" width="260"/>
          <el-table-column prop="addTime" label="时间" width="110"/>
          <el-table-column label="状态" width="80">
            <template #default="scope">
                <p v-if="scope.row.status == 1">待接单</p>
                <p v-else-if="scope.row.status == 2">已接单</p>
                <p v-else-if="scope.row.status == 3">安装中</p>
                <p v-else-if="scope.row.status == 4">待核销</p>
                <p v-else-if="scope.row.status == 5">已完成</p>
                <p v-else-if="scope.row.status == 6">待评价</p>
                <a href="javascrip:void(0)" :title="scope.row.refuseReason" v-else>驳回</a>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template #default="scope">
              <el-button size="small" v-if="scope.row.status < 3 || scope.row.status == 8" @click="showSupplier(scope.row)">设置服务商</el-button>
              <!-- <el-button size="small" v-if="scope.row.status == 2" @click="cancelReceive(scope.row.id)" type="warning">取消接单</el-button> -->
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <!-- <el-button size="small" @click="del(scope.row.id)" type="danger">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
      <el-dialog v-model="baseData.showSupplierBox" title="派发服务商(更改服务商，工单会变成待接单状态)">
        <el-form :model="form">
          <el-form-item label="订单编号" label-width="120">
            {{ form.sn }}
          </el-form-item>
          <el-form-item label="服务商" label-width="120">
            <el-select v-model="form.supplierId">
              <el-option label="" value="" />
              <el-option
                v-for="item in baseData.supplierList"
                :key="item.id"
                :label="item.company"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="baseData.showSupplierBox = false">取消</el-button>
            <el-button type="primary" @click="setSupplier">
              提交
            </el-button>
          </span>
        </template>
      </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const searchForm:any = reactive({
    supplierid:"",
    status:"",
    words:"",
    limit:10,
    page:1,
  })
  const form:any = reactive({
    id:'',
    sn:'',
    supplierId:'',
  })
  const baseData:any = reactive({
    loading:false,
    title:'',
    supplierList:[],
    showSupplierBox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.words = ""
    searchForm.status = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showSupplier = (data:any) => {
    baseData.showSupplierBox = true
    form.id = data.id
    form.sn = data.sn
    form.supplierId = data.supplierid ? data.supplierid : ''
  }
  // const cancelReceive = (id) => {
  //   const loading = ElLoading.service({lock: true})
  //   api.orderApi.cancelReceive({id:id}).then((res:any)=>{
  //     loading.close()
  //     if(res.code==200){
  //       getList()
  //     }else{
  //       ElMessage.error(res.message)
  //     }
  //   })
  // }
  const getSupplierList = () => {
    api.supplierApi.alllist({}).then((res:any)=>{
      if(res.code==200){
        baseData.supplierList = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const setSupplier = () => {
    if(!form.id){
      ElMessage.error('请选择工单')
      baseData.showSupplierBox = false
      return false
    }
    if(!form.supplierId){
      ElMessage.error('请选择服务商')
      baseData.showSupplierBox = false
      return false
    }
    const loading = ElLoading.service({lock: true})
    api.orderApi.setSupplier(form).then((res:any)=>{
      loading.close()
      if(res.code==200){
        baseData.showSupplierBox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    localStorage.setItem('orderspage',searchForm.page);
    localStorage.setItem('orderssupplierid',searchForm.supplierid);
    localStorage.setItem('ordersstatus',searchForm.status);
    localStorage.setItem('orderswords',searchForm.words);
    localStorage.setItem('orderslimit',searchForm.limit);
    baseData.loading = true
    api.orderApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const edit = (id:any) => {
    router.push("/workOrder/edit/"+id);
  }
  // const del = (id:number) => {
  //   baseData.loading = true
  //   api.supplierApi.del({id:id}).then((res:any)=>{
  //     baseData.loading = false
  //     if(res.code==200){
  //       ElMessage({
  //         message: res.message,
  //         type: 'success',
  //       })
  //       getList()
  //     }else{
  //       ElMessage.error(res.message)
  //     }
  //   })
  // }
  onMounted(() => {
    searchForm.page = localStorage.getItem('orderspage')&&localStorage.getItem('orderspage')!=null&&localStorage.getItem('orderspage')!='null' ? parseInt(localStorage.getItem('orderspage') ): 1;
    searchForm.supplierid = localStorage.getItem('orderssupplierid')&&localStorage.getItem('orderssupplierid')!=null&&localStorage.getItem('orderssupplierid')!='null' ? parseInt(localStorage.getItem('orderssupplierid')) : '';
    searchForm.status = localStorage.getItem('ordersstatus')&&localStorage.getItem('ordersstatus')!=null&&localStorage.getItem('ordersstatus')!='null' ? localStorage.getItem('ordersstatus') : '';
    searchForm.words = localStorage.getItem('orderswords')&&localStorage.getItem('orderswords')!=null&&localStorage.getItem('orderswords')!='null' ? localStorage.getItem('orderswords') : '';
    searchForm.limit = localStorage.getItem('orderslimit')&&localStorage.getItem('orderslimit')!=null&&localStorage.getItem('orderslimit')!='null' ? parseInt(localStorage.getItem('orderslimit')) : 10;
    console.log(localStorage.getItem('orderspage'))
    getSupplierList()
    getList()
  })
  </script>